import { fromJS } from 'immutable'
import moment from 'moment'

import {
  TEAM_CALENDAR_GET_REQUEST,
  TEAM_CALENDAR_GET_SUCCESS,
  TEAM_CALENDAR_GET_FAILURE,
  TEAM_CALENDAR_SET_ITEMS,
  TEAM_CALENDAR_SET_MOMENT,
  TEAM_CALENDAR_SET_RANGE,
  TEAM_CALENDAR_SET_SEARCH,
  TEAM_CALENDAR_SET_TAB,
} from '../../constants'

const init = fromJS({
  isFetching: false,
  openedItems: {},
  moment: moment(),
  range: 'month',
  search: '',
  tab: '1',
})

export default (state = init, action) => {
  switch (action.type) {
    case TEAM_CALENDAR_GET_REQUEST:
      return state
        .set('isFetching', true)
    case TEAM_CALENDAR_GET_SUCCESS:
      return state
        .set('isFetching', false)
        .set('teamCalendar', action.payload.teamCalendar)
    case TEAM_CALENDAR_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case TEAM_CALENDAR_SET_ITEMS:
      return state
        .set('openedItems', action.payload)
    case TEAM_CALENDAR_SET_MOMENT:
      return state
        .set('moment', action.payload)
    case TEAM_CALENDAR_SET_RANGE:
      return state
        .set('range', action.payload)
    case TEAM_CALENDAR_SET_SEARCH:
      return state
        .set('search', action.payload)
    case TEAM_CALENDAR_SET_TAB:
      return state
        .set('tab', action.payload)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/team-calendar/team-calendar-reducer.js